// Captures a constrained set of UTM params + the relative landing path (WAIT-4B).
// In-memory only: no cookies, no localStorage, no logging, no analytics.
const MAX = 200; // mirrors backend utm_* length limit
const PATH_MAX = 512; // mirrors backend landing_page_path limit
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content"];

function clean(v, max) {
  if (v == null) return null;
  const t = String(v).trim();
  if (!t) return null;
  return t.slice(0, max);
}

// Reads only the whitelisted UTM params + window.location.pathname.
// Never includes the full URL, hostname, hash, or arbitrary query params.
export function captureAttribution() {
  let params;
  try {
    params = new URLSearchParams(window.location.search || "");
  } catch (_e) {
    params = new URLSearchParams("");
  }
  let path;
  try {
    path = clean(window.location.pathname || "/", PATH_MAX) || "/";
  } catch (_e) {
    path = "/";
  }
  const out = { landing_page_path: path };
  for (const key of UTM_KEYS) {
    out[key] = clean(params.get(key), MAX);
  }
  return out;
}
